import axios from 'axios'

export default axios.create({
  baseURL: `https://backend-rent-car.vercel.app/api/v1`
})
